// extracted by mini-css-extract-plugin
module.exports = {"shadowed":"Imprint_shadowed__3GYe_","pink":"Imprint_pink__3-iZN","green":"Imprint_green__qgF_U","skills":"Imprint_skills__61W9t"};